<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <filter-card :get-data-list="getFilterData" />
      </b-card-body>
      <b-table
        :fields="fields"
        :items="dataList"
      >
        <template #cell(title)="data">
          <div>
            <div class="font-weight-bold text-primary">
              {{ data.item.title }}
            </div>
            <div class="font-small-3 text-muted">
              {{ data.item.component }}
            </div>
          </div>
        </template>
        <template #cell(is_used)="data">
          <div>
            <div class="font-weight-bold text-primary">
              <FeatherIcon
                :icon="data.item.is_used === '1'? 'CheckCircleIcon' : 'XCircleIcon'"
                :class="data.item.is_used === '1'? 'text-success' : 'text-danger'"
              />
            </div>
          </div>
        </template>
        <template #cell(created)="data">
          <div>
            {{ moment(data.item.created).format('DD.MM.YYYY HH:mm') }}
          </div>
        </template>
      </b-table>
      <b-card-footer>
        <b-pagination
          v-if="dataCounts > perPage"
          v-model="currentPage"
          :total-rows="dataCounts"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BTable, BCardBody, BCardFooter, BPagination,
} from 'bootstrap-vue'
import FilterCard from '@/views/DownloadLogs/FilterCard.vue'

export default {
  name: 'DownloadLogs',
  components: {
    BPagination,
    BCard,
    BTable,
    BCardBody,
    BCardFooter,
    FilterCard,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      limit: this.$store.state.app.perPage,
      start: 0,
      fields: [
        {
          key: 'title',
          label: 'TANIM',
          thClass: '',
          tdClass: '',
        },
        {
          key: 'username',
          label: 'KULLANICI',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
        {
          key: 'is_used',
          label: 'DURUM',
          thClass: 'width-50 text-center',
          tdClass: 'width-50 text-center',
        },
        {
          key: 'created',
          label: 'TARİH',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
    }
  },
  computed: {
    filterParams() {
      return this.$store.getters['downloadLogs/filterParams']
    },
    dataList() {
      return this.$store.getters['downloadLogs/dataList']
    },
    dataCounts() {
      return this.$store.getters['downloadLogs/dataCounts']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('downloadLogs/getDataList', {
        sdate: this.filterParams.sdate,
        edate: this.filterParams.edate,
        component: this.filterParams.component,
        id_users: this.filterParams.id_users,
        is_used: this.filterParams.is_used,
        limit: this.limit,
        start: this.start,
      })
    },
    getFilterData() {
      this.limit = this.$store.state.app.perPage
      this.start = 0
      this.getDataList()
    },
  },
}
</script>
